import LeaveReview from "../components/LeaveReview";


const LeaveReviewView = () => {

    return (
        <div className="leave-review">
            <LeaveReview/>
        </div>
    );
};

export default LeaveReviewView;
